import React from 'react'
import Toggle from 'components/Form/Inputs/Toggle'
import { APP_PAGES } from 'components/Engage/utils'
import { getMessage } from 'lib/translator'

const ModuleActions = ({
  page,
  mIsNew,
  mIsEnable,
  onDeleteModule,
  generateStateMappers,
}) => {
  return (
    <div className="module-actions-section">
      <div className="module-status-section">
        <Toggle
          icons={false}
          togglelabel={
            mIsEnable
              ? getMessage('app.layout.enabled')
              : getMessage('app.layout.disabled')
          }
          name="module-status"
          className="module-status-toggle"
          value={mIsEnable ? true : false}
          {...generateStateMappers({
            stateKeys: ['mIsEnable'],
            loseEmphasisOnFill: true,
          })}
        />
      </div>
      {page === APP_PAGES[1] && !mIsNew && (
        <button className="button" type="button" onClick={onDeleteModule}>
          {getMessage('app.layout.module.delete')}
        </button>
      )}
    </div>
  )
}

export default ModuleActions
